import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TriState } from '@app/core/models/timesheet.model';

@Component({
    selector: 'neo-tri-state-toggle',
    templateUrl: './neo-tri-state-toggle.component.html',
    styleUrls: ['./neo-tri-state-toggle.component.scss'],
    standalone: false
})
export class NeoTriStateToggleComponent {
  @Input() activeLabel: string = 'Approve';
  @Input() inactiveLabel: string = 'Reject';
  @Input() value: TriState = TriState.na;
  @Input() disabled: boolean = false;
  @Input() small: boolean = false;

  @Output() valueChange = new EventEmitter<TriState>();

  triStateToggleTrue: TriState = TriState.true;
  triStateToggleFalse: TriState = TriState.false;
  triStateToggleNA: TriState = TriState.na;

  valueChanged(value: TriState): void {
    this.valueChange.emit(value);
  }
}
